<template>
  <Layout>
    <div v-if="characteristicsSet">
      <HostFamilyCharacteristics
        v-if="activeForm === 'hf'"
        v-on:saveFamilyCharacteristics="saveFamilyCharacteristics"
        :characteristics="characteristicsSet.data"
      />
      <AuPairCharacteristics
        :availableCountries="availableCountries.data"
        :characteristics="characteristicsSet.data"
        v-if="activeForm === 'ap' && availableCountries"
        v-on:saveAuPairCharacteristics="saveAuPairCharacteristics"
        v-on:goBack="goBack()"
      />
    </div>
    <ComponentLoading v-else />
  </Layout>
</template>

<script>
import Layout from "@/Layout/Authenticated/Layout.vue";
import HostFamilyCharacteristics from "@/components/Finder/HostFamilyCharacteristics.vue";
import AuPairCharacteristics from "@/components/Finder/AuPairCharacteristics.vue";
import { api } from "@/services.js";

export default {
  name: "Finder",
  components: {
    Layout,
    HostFamilyCharacteristics,
    AuPairCharacteristics,
  },
  data() {
    return {
      activeForm: "hf",
      availableCountries: null,
      characteristicsSet: null,
    };
  },
  methods: {
    saveFamilyCharacteristics() {
      // api
      //   .post(
      //     "/promotional/HostFamily/compatibility",
      //     this.characteristicsSet.data
      //   )
      //   .then((r) => {
      //     this.characteristicsSet.data.id = r.data.id;
      //     this.activeForm = "ap";
      //   })
      //   .catch(() => {
      //     this.$toasted.global.notificate({
      //       message:
      //         "There was an error saving your answers, please try again.",
      //       type: "error",
      //     });
      //   });
      this.activeForm = "ap";
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    saveAuPairCharacteristics() {
      api
        .post(
          "/promotional/HostFamily/compatibility",
          this.characteristicsSet.data
        )
        .then(() => {
          //save was successful, redirect and message the user.
          this.$router.push({ name: "AvailableAuPairs" });
          this.$toasted.global.notificate({
            message: "Your answers were saved correctly.",
            type: "success",
          });
        })
        .catch(() => {
          this.$toasted.global.notificate({
            message:
              "There was an error saving your answers, please try again.",
            type: "error",
          });
        });
    },
    goBack() {
      this.activeForm = "hf";
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  async created() {
    this.characteristicsSet = await api.get(
      "/promotional/HostFamily/compatibility"
    );
    this.availableCountries = await api.get("/promotional/countries");
  },
};
</script>

<style scoped>
fieldset::after {
  content: "";
  width: 100%;
  height: 2px;
  @apply bg-purple-ap-t03;
  position: relative;
  display: block;
  margin: 20px 0;
}
</style>
